import React, { useRef, useState } from "react";
import emailjs from '@emailjs/browser'
import '../form-component/form.css'
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import codeSvg from '../../images/code.svg';


toast.configure();
const Form = ({ signUp }) => {

    const notify = () => {
        toast.success("Submitted!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 20000
        });

    };

    const form = useRef();
    let turnFormOff = false;


    function turnSignUpFalse() {
        signUp(turnFormOff)

    }

    const [serviceNeeded, setServiceNeeded] = useState("");

    const handleChange = (e) => {
        setServiceNeeded(e.target.value);
    };

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_22oze53', 'template_d6aa3f6', form.current, '8ZRgVQVgGHDxy9J0h')
            .then((result) => {
                console.log(result.text);
                signUp(turnFormOff);
            }, (error) => {
                console.log(error.text);
            });
    };


    const [submitted, setSubmitted] = useState(false);
    const handleSubmit = () => {
        setTimeout(() => {
            setSubmitted(true);
        }, 100);
    };

    if (submitted) {
        return (
            <>
            <div className="thankyou"> 
            <h2>Thank you!</h2>
                <div>We'll be in touch soon.</div>
            
            </div>
           </>
        );
    }

    return (
        <div className="form_page ">
            <div>
                <button className="close-form" onClick={turnSignUpFalse}>X</button>
            </div>
            <img className="code-svg" src={codeSvg} alt="email-img" />
            <form className="form" ref={form} onSubmit={sendEmail}>
                <label>
                    <select value={serviceNeeded} onChange={handleChange}>
                        <option selected>What Service Do You Need?</option>
                        <option value="Static Website">Static Website</option>
                        <option value="Responsive Website">Responsive Website</option>
                        <option value="Dynamic Website">Dynamic Website</option>
                        <option value="Landing Page">Landing Page</option>
                        <option value="Web App">Web App</option>
                        <option value="Mobile App">Mobile App</option>
                        <option value="SEO">SEO</option>

                        <option value="Other">other</option>
                    </select>
                </label><br />
                <input type="text"
                    placeholder="Full name"
                    name="user_name"
                    required /> <br />
                <input type="email"
                    placeholder="Email"
                    name="user_email"
                    required /><br />
                <input type="tel" id="phone"
                    pattern="[0-9]{3}[0-9]{3}[0-9]{4}"
                    placeholder="7 digit phone number Example: 6147775555"
                    name="number"
                    required /><br />
                <textarea name="message" color="0" rows="0" value={serviceNeeded} hidden={true} />
                <br />
                <button className="send-btn" onClick={handleSubmit} stype="submit" > Send </button>

            </form>


        </div>


    )
}

export default Form;

